module.exports = __webpack_public_path__ + "static/media/facebook.8a34bd14.svg";